import { useAtom } from "jotai";

import { BudgetMixesAtom, useGlobalMMMStore } from "../mmm-provider";

export const useBudgetMixes = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [budgetMixes, setBudgetMixes] = useAtom(BudgetMixesAtom, {
    store: GlobalMMMStore,
  });

  return [budgetMixes, setBudgetMixes] as const;
};
